import * as React from 'react';
import {
  Chart,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartSeries,
  ChartSeriesItem,
  ChartTitle,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartTooltip,
  ChartLegend,
  ChartXAxis,
  ChartXAxisItem,
  ChartYAxis,
  ChartYAxisItem,
  ChartCategoryAxisCrosshair, ChartCategoryAxisCrosshairTooltip,
  ChartPlotArea
} from '@progress/kendo-react-charts';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import moment from 'moment/moment';

const ChartContainer = ({ data,  portfolio, weightedIndex, csName }) => {
  const [DrawDown, setDrawDow] = useState({ name: "", data: [], Index1Name: "", Index2Name: "", CSName: "" });
  const [upDownData, setUpDownData] = useState({ name: "", plot1: [], plot2: [] });
  const [RiskReturndt, setRiskReturndt] = useState([]);
  const [showContextMenu, setShowContextMenu] = useState(false);



  const periods = [{ value: 3, text: "3 Years" },
  { value: 5, text: "5 Years" },
  { value: 0, text: "Inception" },];
  const [period,setPeriod]=useState(periods[0]);

  
  const setDrawDownFormatting = (data, period, portfolio) => {
    const selectedData =
      period === 0 ? data?.DDChartInception || [] :
        period === 3 ? data?.DDChartThreeYr || [] :
          period === 5 ? data?.DDChartFiveYr || [] :
            [];

    let strategyId = null;
    let chartTitle = "";

    if (portfolio.text === "Advised Performing") {
      strategyId = 999999;
      chartTitle = "Advised Performing Draw Down Chart";
    } else if (portfolio.text === "Total Performing") {
      strategyId = 999;
      chartTitle = "Total Performing Draw Down Chart";
    }
    else if (portfolio.text === "Both") {
      strategyId = 999;
    }

    const filterData = selectedData.find(item => item.StrategyId === strategyId);
    const DDChartData = filterData?.DDChartData || [];

    const categories = [];
    const portfolioArr = [];
    const index1Arr = [];
    const index2Arr = [];
    let index1 = '';
    let index2 = '';
    DDChartData.forEach(group => {
      let peakDate = "";
      let portfolioVal = null, index1Val = null, index2Val = null;

      group.forEach((item, idx) => {
        peakDate = moment(item.DrawdownPoint.PeakDate).format('MMM-YYYY') + '-' + moment(item.DrawdownPoint.ValleyDate).format('MMM-YYYY');
        if (item.EntityId === 999999) {
          portfolioVal = item.DrawdownPoint.PeriodDrawdown;
        } else if (idx === 1) {
          index1Val = item.DrawdownPoint.PeriodDrawdown;
          index1 = item.EntityName;
        } else if (idx === 2) {
          index2Val = item.DrawdownPoint.PeriodDrawdown;
          index2 = item.EntityName;

        }
      });

      categories.push(peakDate);
      portfolioArr.push(portfolioVal ?? 0);
      index1Arr.push(index1Val ?? 0);
      index2Arr.push(index2Val ?? 0);
    });

    setDrawDow(val => ({
      ...val,
      name: chartTitle,
      categories,
      portfolio: portfolioArr,
      index1: index1Arr,
      index2: index2Arr,
      Index1Name: index1,
      Index2Name: index2,
      CSName: data?.ClientStatementName
    }));
  };

  useEffect(() => {
    setDrawDownFormatting(data, period?.value, portfolio);
  }, [period, portfolio, data]);
  useEffect(() => {
    const UpDownCaptureChart = data?.UpDownCaptureChart || [];
    if (portfolio.text == "Advised Performing") {
      const filterData = UpDownCaptureChart.find(item => item.StrategyId == 999999)
      if (filterData) {
        const plot1 = [filterData.UpCapture[0], filterData.DownCapture[0]];
        const plot2 = [filterData.UpCapture[1], filterData.DownCapture[1]];
        setUpDownData(val => ({ ...val, plot1: plot1, plot2: plot2, name: "Advised Performing Up Down Chart" }));
      }
    }
    else if (portfolio.text == "Total Performing") {
      const filterData = UpDownCaptureChart.find(item => item.StrategyId == 999)
      if (filterData) {
        const plot1 = [filterData.UpCapture[0], filterData.DownCapture[0]];
        const plot2 = [filterData.UpCapture[1], filterData.DownCapture[1]];
        setUpDownData(val => ({ ...val, plot1: plot1, plot2: plot2, name: "Total Performing Up Down Chart" }));
      }
    }
    else if (portfolio.text === "Both") {
      const filterData = UpDownCaptureChart.filter(
        item => item.StrategyId === 999 || item.StrategyId === 999999
      );
      if (filterData.length === 2) {
        const plot1 = [
          filterData[0].UpCapture[0] + filterData[1].UpCapture[0],
          filterData[0].DownCapture[0] + filterData[1].DownCapture[0]
        ];
        const plot2 = [
          filterData[0].UpCapture[1] + filterData[1].UpCapture[1],
          filterData[0].DownCapture[1] + filterData[1].DownCapture[1]
        ];
        setUpDownData(val => ({ ...val, plot1, plot2, name: "Advised Performing and Total Performing Up Down Chart" }));
      }
    }
    getchartriskreturndt();
  }, [portfolio, data]);

  //Risk Return Chart Data preparation Start

  const getchartriskreturndt = () => {
    let riskReturnList = [];
    let strategyId = null;

    if (portfolio.text === "Advised Performing") {
      strategyId = 9999;
    } else if (portfolio.text === "Total Performing") {
      strategyId = 999999;
    }
    else
    {
      strategyId = 9999;
      strategyId = 999999;
    }

    if (strategyId) {
      if (period.value === 3) {
        riskReturnList = data?.EFThreeYr?.filter(x => x.StrategyId === strategyId) || [];
      } else if (period.value === 5) {
        riskReturnList = data?.EFFiveYr?.filter(x => x.StrategyId === strategyId) || [];
      } else {
        riskReturnList = data?.EFChart?.filter(x => x.StrategyId === strategyId) || [];
      }

      getriskreturnchartdt(riskReturnList, portfolio.text); // Now applies for all conditions
    }

  }

  const getriskreturnchartdt = (efChartData, riskPerformanceType) => {
    const CSName = csName;
    let SortOrder = 1;
    const dtoLst = [];
    const dataPoints = efChartData?.[0]?.DataPoints || [];
    dataPoints.forEach((riskChart) => {
      if (riskPerformanceType === "Advised Performing" && riskChart.StrategyId === 999999) {
        return;
      }
      if (riskPerformanceType === "Total Performing" && riskChart.StrategyId === 9999) {
        return;
      }

      const securityName = riskChart.StrategyId === 9999
        ? `${CSName} ( Advised Performing )`
        : riskChart.StrategyId === 999999
          ? `${CSName} ( Total Performing )`
          : riskChart.StrategyName;

      const riskReturnDTO = {
        SecurityName: securityName,
        CompoundROR: parseFloat(riskChart.CAGR),
        StandardDeviation: parseFloat(riskChart.StdDev),
        SortOrder: SortOrder,
        SectionId: riskChart.IsIndex
          ? 3
          : dtoLst.some(x => x.SectionId === 1)
            ? 2
            : 1,
      };
      dtoLst.push(riskReturnDTO);
      SortOrder++;
    });
    setRiskReturndt(dtoLst);
  }

  const tooltipRender = (e) => {
    const { dataItem } = e.point || {};
    return `${dataItem?.name || dataItem?.SecurityName}
StandardDeviation: ${(dataItem?.x).toFixed(2)}%
CompoundROR: ${(dataItem?.y).toFixed(2)}%`;
  };


  const maindt = RiskReturndt?.filter(x => x.SectionId === 3);
  const benchmarkData = [
    ...maindt?.map(item => ({
      x: item.StandardDeviation * 100,
      y: item.CompoundROR * 100,
      SecurityName: item.SecurityName
    }))];
  // Highlighted points
  const totaldt = RiskReturndt?.find(x =>
    x.SecurityName?.includes("( Total Performing )")
  );
  const totalPoint = {
    x: totaldt?.StandardDeviation * 100,
    y: totaldt?.CompoundROR * 100,
    SecurityName:totaldt?.SecurityName,
    color: "darkred"
  };

  const adviseddt = RiskReturndt?.find(x =>
    x.SecurityName?.includes("( Advised Performing )")
  );
  const advisedPoint = {
    x: adviseddt?.StandardDeviation * 100,
    y: adviseddt?.CompoundROR * 100,
    SecurityName: adviseddt?.SecurityName,
    color: "steelblue"
  };
  const chartRef = useRef(null);
  const chartRef1 = useRef(null);
  const chartRef2 = useRef(null);
  const chartRef3 = useRef(null);

  const copyChartToClipboard = async (chartWrapperRef,title) => {
    const svgElement = chartWrapperRef.current.querySelector('svg');

    if (!svgElement) {
      console.error('SVG not found in Kendo chart.');
      return;
    }

    const width = svgElement.clientWidth;
    const height = svgElement.clientHeight;
    const svgData = new XMLSerializer().serializeToString(svgElement);

    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();
    const paddingTop = 40;
    img.onload = async () => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.color = '#000'; // Black text
      ctx.font = '16px Arial';
      ctx.textAlign = 'center';
      ctx.fillText(title, width / 2, 25); 
      ctx.drawImage(img, 0, paddingTop);
      URL.revokeObjectURL(url);
      canvas.toBlob(async (blob) => {
        try {
          await navigator.clipboard.write([
            new ClipboardItem({ 'image/png': blob })
          ]);
        } catch (err) {
          console.error('Clipboard error:', err);
        }
      });
    };

    img.src = url;
  };

  const chartButtonNames = [
    { value: 0, label: "All" },
    { value: 1, label: "UP/Down" },
    // { value: 2, label: "DrawDown 1" },
    { value: 3, label: "DrawDown" },
    { value: 4, label: "Risk Return" },
  ];
  const [selectedChartButton, setSelectedChartButton] = useState(chartButtonNames[0]);
  const handleMouseEnter = () => {
    setShowContextMenu(true);
  };
  const handleMouseLeave = () => {
    setShowContextMenu(false);
  };

  const handleRadioChange=(valu)=>{
    setPeriod(val=>periods.find(item=>item.value==valu))
  }
  return (
    <div>
      {(
        <div className="d-flex justify-content-end my-3">
          <div className="button-container">
            {chartButtonNames.map((option) => (
              <button
                key={option.value}
                value={option.value}
                className={`non-gappable-button ${selectedChartButton.value === option.value
                  ? "selected-non-gappable-button"
                  : ""
                  }`}
                onClick={() => { setSelectedChartButton(option) }}
                onMouseEnter={() => { option.value == 3 && handleMouseEnter() }}
              >
                {option.label}
              </button>
            ))}


            {showContextMenu && (
              <div className="context-menu" style={{left:"10%",width:"max-content"}} onMouseLeave={() => { handleMouseLeave() }}>
                <h4>Periods</h4>
                <div style={{ display: "flex", gap: "10px" }}>
                  <label className='d-flex gap-2 align-items-center m-0'>
                    <input type="radio" name="period" value="0" checked={period.value == 0} onChange={() => handleRadioChange(0)} /> <label className='m-0' >Inception</label>
                  </label>
                  <label className='d-flex gap-2 align-items-center m-0'> 
                    <input type="radio" name="period" value="3" checked={period.value == 3} onChange={() => handleRadioChange(3)} /> <label className='m-0'>3 Years</label>
                  </label>
                  <label className='d-flex gap-2 align-items-center m-0'>
                    <input type="radio" name="period" value="5" checked={period.value == 5} onChange={() => handleRadioChange(5)} /> <label className='m-0'>5 Years</label>
                  </label>
                </div>
              </div>
            )}
          </div>

        </div>
      )}
      <div className="row">
        {(selectedChartButton.value == 0 || selectedChartButton.value == 1) && 
        <div className="col-md-6 rounded border p-2 my-2">
          <div className='d-flex my-2 mx-1 py-3 border-bottom'>
            <div className='fs-5 fw-semibold'>
              {upDownData.name}
            </div>

            <div className='ms-auto  SBA_hand'  onClick={() => { copyChartToClipboard(chartRef,upDownData.name) }}>
            <i
              className="fa fa-copy mx-2"
              title="Copy Chart as Image"
             
              style={{
                fontSize: 18,
                color: "#aec0cd",
              }}
            ></i>
            <span >Copy</span>
            </div>

          </div >
          <div ref={chartRef} >
            <Chart style={{ height: 400 }}>
             <ChartTitle 
            //  text={upDownData.name}
              />
              <ChartValueAxis>
                <ChartValueAxisItem
                  line={{ color: 'black' }}
                  majorGridLines={{ visible: false }}
                  labels={{
                    visible: true,
                    format: "{0:P2}",
                    rotation: "auto",
                  }} />

              </ChartValueAxis>

              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  majorGridLines={{ visible: false }}
                  axisCrossingValue={0}
                  line={{ color: 'black' }}
                  labels={{
                    visible: false,
                    rotation: 0,
                  }}
                />
              </ChartCategoryAxis>
              <ChartSeries>
                <ChartSeriesItem
                  type="column"
                  data={upDownData.plot1}
                  color={(point) => (point.value >= 0 ? "#4470AD" : "#7d9cb6 ")}
                  spacing={0.1}
                  tooltip={{ visible: true, format: "{0:P2}", template: "Value: #= value #" }}

                />
                <ChartSeriesItem
                  type="column"
                  data={upDownData.plot2}
                  color={(point) => (point.value >= 0 ? "#4470AD" : "#7d9cb6 ")}
                  tooltip={{ visible: true, format: "{0:P2}", template: "Value: #= value #" }}

                />
              </ChartSeries>
            </Chart>
          </div>
        </div>}
        {/* <div className="col-md-6">
          <Chart>
            <ChartTitle text={upDownData.name} />
            <ChartValueAxis>
              <ChartValueAxisItem
                line={{ color: 'black' }}

                labels={{
                  visible: true,
                  format: "{0:P2}",
                  rotation: "auto",
                }} />
            </ChartValueAxis>
            <ChartCategoryAxis>
              <ChartCategoryAxisItem
                axisCrossingValue={0}
                line={{ color: 'black' }}
                labels={{
                  visible: false,
                  rotation: 0,
                }}
              />
            </ChartCategoryAxis>
            <ChartSeries>
              <ChartSeriesItem
                type="column"
                data={upDownData.plot1}
                color={(point) => (point.value >= 0 ? "#4470AD" : "#7d9cb6 ")}
                spacing={0.1}
                tooltip={{ visible: true, format: "{0:P2}", template: "Value: #= value #" }}

              />
              <ChartSeriesItem
                type="column"
                data={upDownData.plot2}
                color={(point) => (point.value >= 0 ? "#4470AD" : "#7d9cb6 ")}
                tooltip={{ visible: true, format: "{0:P2}", template: "Value: #= value #" }}

              />
            </ChartSeries>
          </Chart>
        </div> */}
        {(selectedChartButton.value == 0 || selectedChartButton.value == 3) && 
         <div className="col-md-12 rounded border p-2 my-2">
         <div className='d-flex my-2 mx-1 py-3 border-bottom'>
           <div className='fs-5 fw-semibold'>
             {DrawDown.name}
           </div>

           <div className='ms-auto  SBA_hand' 
           onClick={() => { copyChartToClipboard(chartRef2,DrawDown.name) }}
           >
           <i
             className="fa fa-copy mx-2"
             title="Copy Chart as Image"
             
             style={{
              fontSize: 18,
              color: "#aec0cd",
            }}
          ></i>
          <span   >Copy</span>
           </div>

         </div >
          <div ref={chartRef2} >
            <Chart>
              <ChartLegend position="bottom" orientation="horizontal" />
              <ChartTitle 
              // text={DrawDown.name}
               margin={20} />
              <ChartCategoryAxis>
                <ChartCategoryAxisItem
                  majorGridLines={{ visible: false }}
                  categories={DrawDown.categories}
                  axisCrossingValue={0}
                  line={{ color: 'black' }}
                  labels={{
                    visible: false,
                    rotation: 0,
                  }}
                />
              </ChartCategoryAxis>

              <ChartValueAxis>
                <ChartValueAxisItem
                  majorGridLines={{ visible: false }}
                  line={{ color: 'black' }}
                  labels={{
                    visible: true,
                    format: "{0:P2}",
                    rotation: "auto",
                  }} />
              </ChartValueAxis>
              <ChartSeries>
                <ChartSeriesItem
                  name={DrawDown.CSName}
                  type="column"
                  data={DrawDown.portfolio}
                  color="#345f94"
                  tooltip={{ visible: true, format: "{0:P2}", template: "Value: #= value #" }}
                  spacing={0.3}
                  labels={{
                    visible: true,
                    format: "{0:P2}",
                    rotation: "auto",
                    background: "none",
                    margin: 30
                  }}
                />
                <ChartSeriesItem
                  name={DrawDown.Index1Name}
                  type="column"
                  data={DrawDown.index1}
                  color="#89b1bb"
                  tooltip={{ visible: true, format: "{0:P2}", template: "Value: #= value #" }}
                  spacing={0.3}
                  labels={{
                    visible: true,
                    format: "{0:P2}",
                    rotation: "auto",
                    background: "none",
                    margin: 30

                  }}
                />
                <ChartSeriesItem
                  name={DrawDown.Index2Name}
                  type="column"
                  data={DrawDown.index2}
                  color="#78a779"
                  tooltip={{ visible: true, format: "{0:P2}", template: "Value: #= value #" }}
                  labels={{
                    visible: true,
                    format: "{0:P2}",
                    rotation: "auto",
                    background: "none",
                    margin: 30
                  }}
                />
              </ChartSeries>
            </Chart>
          </div>
        </div>}
        {(selectedChartButton.value == 0 || selectedChartButton.value == 4) &&
          <div className="col-md-12 rounded border p-2 my-2">
          <div className='d-flex my-2 mx-1 py-3 border-bottom'>
            <div className='fs-5 fw-semibold'>
              {"Risk Return"}
            </div>
 
            <div className='ms-auto  SBA_hand'
              onClick={() => { copyChartToClipboard(chartRef3,'Risk Return') }}
            >
            <i
              className="fa fa-copy mx-2"
              title="Copy Chart as Image"
            
              style={{
                fontSize: 18,
                color: "#aec0cd",
              }}
            ></i>
            <span   >Copy</span>
            </div>
 
          </div >
            <div ref={chartRef3} >
              <Chart>
                <ChartTitle 
                //text="" 
                />
                <ChartLegend visible={false} />
                <ChartTooltip render={tooltipRender} />
                {/* X Axis - Standard Deviation */}
                <ChartXAxis>
                  <ChartXAxisItem
                    majorGridLines={{ visible: false }}
                    title={{ text: "Standard Deviation" }}
                    min={0}
                    max={20}
                    plotBands={[
                      {
                        from: 9.99,
                        to: 10.01,
                        color: "gray",
                        opacity: 1
                      }
                    ]}
                  />
                </ChartXAxis>
                {/* Y Axis - Compound ROR */}
                <ChartYAxis>
                  <ChartYAxisItem
                    majorGridLines={{ visible: false }}
                    title={{ text: "Compound ROR" }}
                    min={0}
                    max={12}
                    plotBands={[
                      {
                        from: 2.49,
                        to: 2.51,
                        color: "gray",
                        opacity: 1
                      }
                    ]}
                  />
                </ChartYAxis>
                {/* Data Series */}
                <ChartSeries>
                  <ChartSeriesItem
                    type="scatterLine"
                    data={benchmarkData}
                    xField="x"
                    yField="y"
                    labels={{
                      visible: true,
                      content: e => e.dataItem.SecurityName,
                      position: "top"
                    }}
                    color="#7d9cb6"
                  />
                  {/* Advised Point */}
                  <ChartSeriesItem
                    type="scatter"
                    data={[advisedPoint]}
                    xField="x"
                    yField="y"
                    markers={{
                      type: "diamond",
                      size: 10,
                      background: advisedPoint.color
                    }}
                    labels={{
                      visible: true,
                      content: () => advisedPoint.SecurityName,
                      position: "bottom"
                    }}
                  />

                  {/* Total Point */}
                  <ChartSeriesItem
                    type="scatter"
                    data={[totalPoint]}
                    xField="x"
                    yField="y"
                    markers={{
                      type: "diamond",
                      size: 10,
                      background: totalPoint.color
                    }}
                    labels={{
                      visible: true,
                      content: () => totalPoint.SecurityName,
                      position: "bottom"
                    }}
                  />
                </ChartSeries>
              </Chart>
            </div>
          </div>
        }
      </div>

    </div>
  );
};
export default ChartContainer